import { CircularProgressProps, Box, CircularProgress, Typography } from '@mui/material';

type CircularProgressWithLabelProps = CircularProgressProps & {
  hideLabel?: boolean;
  value: number;
};

function CircularProgressWithLabel({ hideLabel, ...rest }: CircularProgressWithLabelProps) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" {...rest} />
      {!hideLabel && (
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: 'text.secondary' }}
          >{`${Math.round(rest.value)}%`}</Typography>
        </Box>
      )}
    </Box>
  );
}

export default CircularProgressWithLabel;
